import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import { ActionsDropdown } from "components/Dropdowns"
import {
  CheckboxField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { Field, formValueSelector, reduxForm, reset } from "redux-form"
import { getEvents, selectAllEvents } from "store/actions"
import { checkPermission, userIsCorporate, userIsGodMode } from "utils"

const HeaderLine = ({
  businessUnits,
  business_unit_id,
  handleSubmit,
  reset,
  getEvents,
  eventsSortOptions,
  selectAllEvents,
  clientConfig,
  resetSelectedEvents,
}) => {
  const [showMoreFilters, setShowMoreFilters] = useState(false)
  const [showResetButton, setShowResetButton] = useState(false)

  const menuActions = [
    ...(checkPermission("manage_business_units") &&
    (userIsGodMode() || userIsCorporate())
      ? [
          {
            name: "Manage Business Units",
            onClick: () => {
              window.location.href = "/business-units"
            },
            icon: "bx bxs-business",
            isAvailable: true,
          },
        ]
      : []),
    ...(clientConfig.categorize_experiences === 1
      ? [
          {
            name: "Manage Categories",
            onClick: () => {
              window.location.href = "/categories"
            },
            icon: "bx bx-grid-alt",
            isAvailable: true,
          },
        ]
      : []),
  ]

  const resetSearch = () => {
    reset()
    setShowResetButton(false)
    getEvents(eventsSortOptions)
    resetSelectedEvents()
    selectAllEvents(false)
  }

  return (
    <React.Fragment>
      <form
        onSubmit={event => {
          event.preventDefault()
          handleSubmit()
          setShowResetButton(true)
        }}
      >
        <BreadcrumbTitle
          title="Experiences"
          breadcrumbItems={[{ title: "Dashboard" }, { title: "Experiences" }]}
        />
        <Row>
          <Col className="d-flex justify-content-center">
            <Row className="form-group">
              <Col xs={12} sm={6} md="auto" className="my-1">
                <Field
                  name={"search"}
                  placeholder={"Search"}
                  component={TextField}
                />
              </Col>
              <Col xs={12} sm={6} md="auto" className="my-1">
                <SaveButton
                  content={showMoreFilters ? "Hide filters" : "More filters"}
                  color={"light"}
                  onClick={() => setShowMoreFilters(!showMoreFilters)}
                  type="button"
                  fullWidth={true}
                />
              </Col>
              <Col xs={12} sm="auto" className="d-none d-md-block my-1">
                <SaveButton content={"Search"} fullWidth={true} />
              </Col>
              {showResetButton && (
                <Col xs={12} sm="auto" className="d-none d-md-block my-1">
                  <SaveButton
                    content={"Reset"}
                    color="light"
                    fullWidth={true}
                    type="button"
                    onClick={resetSearch}
                  />
                </Col>
              )}
            </Row>
          </Col>
          <Col
            xs={1}
            style={{ minWidth: "fit-content" }}
            className="my-1 d-none d-md-block"
          >
            {((checkPermission("manage_business_units") &&
              (userIsGodMode() || userIsCorporate())) ||
              clientConfig.categorize_experiences === 1) && (
              <ActionsDropdown
                label={"Menu"}
                icon={"mdi mdi-dots-vertical"}
                actionsList={menuActions}
                menuPosition={"end"}
                fullWidth={true}
              />
            )}
          </Col>
        </Row>
        {showMoreFilters && (
          <Row className="px-1 py-3">
            <Col md={4} xl={3}>
              <div className={"mb-3"}>
                <Field
                  value={business_unit_id}
                  name={"business_unit_id"}
                  label={"Business Unit"}
                  component={SingleSelectField}
                  options={[
                    ...businessUnits.map(bu => ({
                      value: bu.id,
                      label: bu.name,
                    })),
                    { value: "global", label: "Global" },
                    { value: "view_all", label: "View All" },
                  ]}
                />
              </div>
            </Col>
            <Col xs="auto" className="pt-2">
              <div className={"mb-3 inlineFormCheckbox"}>
                <Field
                  name={"active"}
                  label={"Hide Inactive Experiences"}
                  component={CheckboxField}
                />
              </div>
            </Col>
          </Row>
        )}
        <Row className="d-md-none d-flex justify-content-center">
          <Col xs={showResetButton ? 6 : 12} sm={6}>
            <SaveButton content={"Search"} fullWidth={true} />
          </Col>
          {showResetButton && (
            <Col xs={6}>
              <SaveButton
                content={"Reset"}
                color="light"
                fullWidth={true}
                type="button"
                onClick={resetSearch}
              />
            </Col>
          )}
        </Row>
        <Row className="d-md-none">
          <Col xs="auto" style={{ minWidth: "fit-content" }} className="my-1">
            {((checkPermission("manage_business_units") &&
              (userIsGodMode() || userIsCorporate())) ||
              clientConfig.categorize_experiences === 1) && (
              <ActionsDropdown
                label={"Menu"}
                icon={"mdi mdi-dots-vertical"}
                actionsList={menuActions}
                menuPosition={"end"}
                fullWidth={true}
              />
            )}
          </Col>
        </Row>
      </form>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.EXPERIENCES_FILTER)

const mapStateToProps = state => ({
  businessUnits: state.businessUnits.businessUnits,
  business_unit_id: selector(state, "business_unit_id"),
  eventsSortOptions: state.experiences.eventsSortOptions,
  clientConfig: state.Login.clientConfig,
})

const mapDispatchToProps = dispatch => ({
  reset: () => dispatch(reset(FORM_NAMES.EXPERIENCES_FILTER)),
  getEvents: values => dispatch(getEvents(values)),
  selectAllEvents: isSelected => dispatch(selectAllEvents(isSelected)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.EXPERIENCES_FILTER })(HeaderLine))
